import { useEffect } from 'react';
import { FiX } from 'react-icons/fi';

interface ToastProps {
  id: number;
  message: string;
  type?: 'success' | 'error' | 'info';
  onClose: (id: number) => void;
}

export default function Toast({ id, message, type = 'success', onClose }: ToastProps) {
  useEffect(() => {
    if (type === 'success') {
      const t = setTimeout(() => onClose(id), 2000);
      return () => clearTimeout(t);
    }
  }, [id, onClose, type]);

  const isError = type === 'error';
  return (
    <div className={`rounded-xl shadow-xl border p-4 mb-3 min-w-[280px] max-w-[380px] animate-slide-in-right ${
      isError
        ? 'bg-red-50/95 border-red-200 dark:bg-red-900/95 dark:border-red-700'
        : 'bg-blue-50/95 border-blue-200 dark:bg-blue-900/95 dark:border-blue-700'
    }`}>
      <div className="flex items-start gap-3">
        <p className={`flex-1 text-sm font-medium ${isError ? 'text-red-900 dark:text-red-100' : 'text-gray-900 dark:text-gray-100'}`}>
          {message}
        </p>
        {isError && (
          <button onClick={() => onClose(id)} className="p-1 rounded hover:bg-red-100 dark:hover:bg-red-800/50 flex-shrink-0" title="Закрыть">
            <FiX className="w-4 h-4 text-red-700 dark:text-red-300" />
          </button>
        )}
      </div>
    </div>
  );
}
